module.exports = __webpack_public_path__ + "media/src/images/businessStats3-269f934876c7ab950d7eb61014a6faf1.svg";